<template>
  <div class="user-management gray-6 bg">
    <nav-bar />
    <div class="content">
      <div class="side-container">
        <side-nav />
        <md-button
          v-if="isAdminOrInstructor"
          key="ORG_MANAGEMENT"
          category="ORG_MANAGEMENT"
          class="vrp-pill-button org-management-button"
          @click="openTutorialDrawer('ORG_MANAGEMENT')"
        >
          Video Tutorials
        </md-button>
      </div>
      <md-app class="profile">
        <md-app-drawer class="gray-1 bg" md-permanent="clipped">
          <md-list class="gray-1 bg">
            <md-list-item v-if="isKeyOwner" to="/org/profile">
              <span class="md-list-item-text">Org. Profile</span>
            </md-list-item>
            <md-list-item v-if="isAdminOrInstructor" to="/org/invite">
              <span class="md-list-item-text">Users</span>
            </md-list-item>
            <md-list-item to="/org/groups">
              <span class="md-list-item-text">Groups</span>
            </md-list-item>
            <md-list-item v-if="isAdminOrInstructor" to="/org/archived-users">
              <span class="md-list-item-text">Grading Archive</span>
            </md-list-item>
          </md-list>
        </md-app-drawer>

        <md-app-content class="gray-1 bg">
          <router-view />
        </md-app-content>
      </md-app>
      <md-drawer
        v-if="isAdminOrInstructor"
        class="tutorial-drawer"
        :md-fixed="true"
        :md-active.sync="state.tutorialDrawerOpen"
        @md-closed="closeTutorialDrawer"
      >
        <tutorial-list
          v-if="state.tutorialDrawerOpen"
          :category="state.tutorialDrawerCategory"
          @close="closeTutorialDrawer"
        />
      </md-drawer>
    </div>
  </div>
</template>

<script>
import SideNav from '~lib/common/components/SideNav';
import NavBar from '~lib/common/components/NavBar';
import TutorialList from '~lib/common/components/Tutorials/TutorialList.vue';

export default {
  name: 'org-management',
  components: {
    SideNav,
    NavBar,
    TutorialList,
  },
  props: {
    isAdmin: {
      type: Boolean,
      default: false,
    },
    isKeyOwner: {
      type: Boolean,
      default: false,
    },
    isAdminOrInstructor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      state: {
        tutorialDrawerOpen: false,
        tutorialDrawerCategory: null,
      }
    };
  },
  created() {
    this.$analytics.event('Org Management', 'org_management_page');
  },
  methods: {
    openTutorialDrawer(category) {
      this.state.tutorialDrawerCategory = category;
      this.state.tutorialDrawerOpen = true;
    },
    closeTutorialDrawer() {
      this.state.tutorialDrawerOpen = false;
    }
  },
};
</script>

<style scoped>
.user-management {
  display: flex;
  flex-direction: column;
}
.content {
  flex: 1;
  display: flex;
  height: calc(100% - 88px);
}
.md-app {
  height: 100%;
  flex: 1;
}

.md-app-drawer {
  width: 250px;
}

.md-app >>> .md-app-scroller {
  height: 100%;
}

.side-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 15%;
}

.side-nav {
  width: 100%;
}

.org-management-button {
  position: absolute;
  left: 10px;
  bottom: 4px;
  width: 140px;
  z-index: 5;
}

.tutorial-drawer {
  min-width: 640px;
}
</style>
